import { Discount, Plan } from '../types';

export interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  acceptTerms: boolean;
  showVatFields: boolean;
  usePromoCode: boolean;
  promoCode: string;
  plan: Plan;
  paymentElementComplete: boolean;
  paymentMethod: string;
  isEuropeanUnion: boolean;
  emailOptIn: boolean;
  vatNumber: string;
  company: string;
  discount: Discount;
  isUAE: boolean;
  currency: string;
  country: string;
  postalCode: string;
  address: {
    complete: boolean;
    name: string;
    line1: string;
    line2: string | null;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
}

export const initialValues: FormValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  acceptTerms: false,
  emailOptIn: false,
  showVatFields: false,
  usePromoCode: false,
  promoCode: '',
  plan: 'monthly',
  paymentElementComplete: false,
  paymentMethod: '',
  country: 'US',
  isEuropeanUnion: false,
  vatNumber: '',
  company: '',
  discount: { percentOff: 0, amountOff: 0, terms: null, id: null, duration: null, trialDays: null },
  isUAE: false,
  currency: '',
  postalCode: '',
  address: {
    complete: false,
    name: '',
    line1: '',
    line2: null,
    city: '',
    state: '',
    postal_code: '',
    country: '',
  },
};
